import { useSelector, useDispatch } from 'react-redux';
import {
    Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box, Alert, alpha
} from '@mui/material';
import { Delete as DeleteIcon, Close as CloseIcon, Warning as WarningIcon } from '@mui/icons-material';

import * as actions from '../redux.actions';
import * as selectors from '../redux.selectors';

const DeleteConfirmationDialog = () => {
    const dispatch = useDispatch();
    const isOpen = useSelector(selectors.isDeleteDialogOpenSelector);
    const selected = useSelector(selectors.selectedClientSelector);
    const loading = useSelector(selectors.loadingSelector);

    const handleClose = () => dispatch(actions.closeDeleteDialog());
    const handleConfirm = () => selected && dispatch(actions.deleteClient(selected.id));

    return (
        <Dialog open={isOpen} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <WarningIcon color="error" /> Confirm Delete
            </DialogTitle>
            <DialogContent dividers>
                <Alert severity="warning" sx={{ mb: 2 }}>
                    This action cannot be undone. The client and all nested records (websites, periods, employees, team assignments) will be permanently deleted.
                </Alert>
                {selected && (
                    <Box>
                        <Typography variant="body1">Are you sure you want to delete this client?</Typography>
                        <Box sx={(theme) => ({ mt: 2, p: 2, bgcolor: alpha(theme.palette.divider, 0.06), borderRadius: 1 })}>
                            <Typography variant="body1"><strong>Name:</strong> {selected.name}</Typography>
                            <Typography variant="body2" sx={{ mt: 1 }}><strong>Type:</strong> {selected.type}</Typography>
                            {selected.industry && (
                                <Typography variant="body2" sx={{ mt: 1 }}><strong>Industry:</strong> {selected.industry}</Typography>
                            )}
                        </Box>
                    </Box>
                )}
            </DialogContent>
            <DialogActions sx={{ p: 2, gap: 1 }}>
                <Button onClick={handleClose} startIcon={<CloseIcon />} disabled={loading}>Cancel</Button>
                <Button onClick={handleConfirm} variant="contained" color="error" startIcon={<DeleteIcon />} disabled={loading}>
                    Delete
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteConfirmationDialog;
